import * as d3 from 'd3';
import type { HierarchyPointLink, HierarchyPointNode } from 'd3-hierarchy';
import { gapBetweenNodes } from '../model';

export function nodeHorizontalLayout<DataNode>(root: HierarchyPointNode<DataNode>, nodeWidth: number) {
  root.each(d => {
    const newX = d.y * nodeWidth + d.depth * gapBetweenNodes;
    const newY = 0;
    d.x = newX;
    d.y = newY;
  });
}

export function nodeVerticalLayout<DataNode>(root: HierarchyPointNode<DataNode>, nodeHeight: number) {
  root.each(d => {
    const newX = 0;
    const newY = d.y * nodeHeight + d.depth * gapBetweenNodes;
    d.x = newX;
    d.y = newY;
  });
}

export function linkHorizontal<DataNode>(d: HierarchyPointLink<DataNode>, nodeWidth: number, nodeHeight: number) {
  return d3.linkHorizontal()({
    source: [d.source.x + nodeWidth, d.source.y + nodeHeight / 2], // start the diagonal at the (0,0) position, later g.linkGroup will be moved/scaled to connect nodes
    target: [d.target.x, d.target.y + nodeHeight / 2], // x y transposed
  });
}

export function linkVertical<DataNode>(d: HierarchyPointLink<DataNode>, nodeWidth: number, nodeHeight: number) {
  return d3.linkVertical()({
    source: [d.source.x + nodeWidth / 2, d.source.y + nodeHeight], // start the diagonal at the (0,0) position, later g.linkGroup will be moved/scaled to connect nodes
    target: [d.target.x + nodeWidth / 2, d.target.y], // x y transposed
  });
}
